/** Exchange rate source for the accounting-totals autofill. */
export const InvoiceAutofillRateSource = {
  /** Only the rate stated on the invoice. */
  INVOICE_ONLY: 'INVOICE_ONLY',
  /** Invoice rate first, CNB/ECB when the invoice carries none. */
  INVOICE_THEN_EXTERNAL: 'INVOICE_THEN_EXTERNAL',
  /** Always the CNB/ECB rate — overrides the rate stated on the invoice. */
  EXTERNAL_ALWAYS: 'EXTERNAL_ALWAYS'
} as const;

export type InvoiceAutofillRateSource =
  (typeof InvoiceAutofillRateSource)[keyof typeof InvoiceAutofillRateSource];
